module.exports = __webpack_public_path__ + "saira-bold-webfont.88afaba35000fdad33b8.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-bold-webfont.ttf
// module id = ../../../../../src/assets/fonts/saira-bold-webfont.ttf
// module chunks = styles